const pageNameKey = "markdownSupportPopover";

export const markdownSupportPopoverEn = {
  [pageNameKey]: {
    supportMarkDownFormatting: "Supported Markdown Formatting",
    regularList: "Regular List",
    item: "Item",
    subItem: "Sub Item",
    orderedList: "Ordered List",
    first: "First",
    second: "Second",
  },
};

export const markdownSupportPopoverPtBr = {
  [pageNameKey]: {
    supportMarkDownFormatting: "Formatação Markdown compatível",
    regularList: "Lista regular",
    item: "Item",
    subItem: "Subitem",
    orderedList: "Lista ordenada",
    first: "Primeiro",
    second: "Segundo",
  },
};

export const markdownSupportPopoverDe = {
  [pageNameKey]: {
    supportMarkDownFormatting: "Unterstützte Markdown-Formatierung",
    regularList: "Ungeordnete Liste",
    item: "Element",
    subItem: "Unterelement",
    orderedList: "Geordnete Liste",
    first: "Erste",
    second: "Zweite",
  },
};

export const markdownSupportPopoverZhHans = {
  [pageNameKey]: {
    supportMarkDownFormatting: "支持的 Markdown 格式",
    regularList: "无序列表",
    item: "项目",
    subItem: "子项目",
    orderedList: "有序列表",
    first: "第一",
    second: "第二",
  },
};

export const markdownSupportPopoverIt = {
  [pageNameKey]: {
    supportMarkDownFormatting: "Formattazione Markdown Supportata",
    regularList: "Elenco non ordinato",
    item: "Elemento",
    subItem: "Sub-elemento",
    orderedList: "Elenco ordinato",
    first: "Primo",
    second: "Secondo",
  },
};

export const markdownSupportPopoverEs = {
  [pageNameKey]: {
    supportMarkDownFormatting: "Formato Markdown compatible",
    regularList: "Lista normal",
    item: "Artículo",
    subItem: "Subelemento",
    orderedList: "Lista ordenada",
    first: "Primero",
    second: "Segundo",
  },
};

export const markdownSupportPopoverNl = {
  [pageNameKey]: {
    first: "Eerste",
    item: "Item",
    orderedList: "Geordende lijst",
    regularList: "Ongeordende lijst",
    second: "Tweede",
    subItem: "Subitem",
    supportMarkDownFormatting: "Ondersteunde Markdown-opmaak",
  },
};

export const markdownSupportPopoverTr = {
  [pageNameKey]: {
    first: "Birinci",
    item: "Öğe",
    orderedList: "Sıralı Liste",
    regularList: "Düzenli Liste",
    second: "Saniye",
    subItem: "Alt Öğe",
    supportMarkDownFormatting: "Desteklenen Markdown Formatlaması",
  },
};
